import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import { useNavigate } from 'react-router-dom'
import AuthProvider from '../Authentication/authProvider'
import axios from 'axios'
import { useEffect, useState, useRef } from 'react'
import DivBottom from '../userNotAuth/components/divBottom'

function ProfiloFoodTruck() {
    const navigate = useNavigate()
    const [userId, setUserId] = useState(localStorage.getItem('id'))
    const [foodTrucks, setFoodTrucks] = useState([])
    const [dati, setDati] = useState({})
    const [msg, setMsg] = useState({ noProfilo: null })
    const [img, setImg] = useState([])
    const [tipoCucina, setTipoCucina] = useState([])

    const confirmElimina = useRef()
    const corpo = useRef()//per opacity diminuita quando clicco elimina artista

    async function getFoodTrucks() {
        try {
            const res = await axios.post(`/getArtista/${userId}`)
            const uio = res.data.filter(item => item.sezione === "truck")
            setFoodTrucks(uio)
            if (uio[0].img) setImg(uio[0].img.split(','))

            setTipoCucina(uio[0].genere.split(','))
            if (res.data.length === 0) setMsg({
                noProfilo: 'Non hai ancora nessun profilo come FoodTruck da mostrare oppure' +
                    ' hai inserito un FoodTruck ma lo staff deve ancora approvarlo.'
            })
        } catch (err) { console.log(err) }
    }
    function modifica(foodTruck) {
        setTimeout(() => {
            navigate('/editFoodTruck', {
                replace: true,
                state: { foodTruck }
            })
        }, 300)
    }
    const approva = (stato) => {
        try {
            axios.post(`/approvaArtista/${dati.id}/${dati.emailUser}/${stato}/${dati.idUser}`).then(res => {
                confirmElimina.current.style.top = '-50%'
                corpo.current.style.opacity = "1"
                document.body.style.overflow = "scroll"
                if (stato === 'delete') {
                    if (dati.img) { axios.delete(`/delete-img/${dati.img}`) }
                    if (dati.video) { axios.delete(`/delete-video/${dati.video}`) }
                }
                setTimeout(() => { window.location.reload() }, 300)
            })
        } catch (err) { console.log(err) }
    }
    useEffect(() => { getFoodTrucks() }, [userId])
    useEffect(() => { console.log(foodTrucks) }, [foodTrucks])
    return (<>
        <NavbarNotAuth />
        <br />
        <div ref={confirmElimina} style={{
            position: 'fixed',
            backgroundColor: 'snow',
            top: '-50%',
            left: '0',
            right: '0',
            margin: 'auto',
            width: '70%',
            height: '40%',
            padding: '2rem',
            zIndex: '1',
            borderRadius: '10px',
            border: '1px solid black',
            textAlign: 'center',
            transition: '.2s'
        }}>
            Eliminare definitivamente <i>{dati.genere}</i> ?
            <div className='mt-5'>
                <button className='float-start btn btn-danger'
                    onClick={() => { approva('delete') }}>Procedi</button>
                <button className='float-end btn btn-success'
                    onClick={() => {
                        confirmElimina.current.style.top = '-50%'
                        corpo.current.style.opacity = "1"
                        document.body.style.overflow = "scroll"
                    }}>Annulla</button>
            </div>
        </div>
        <h1 style={{ cursor: 'pointer', margin: '2em 0 0 .5em' }} onClick={() => { navigate('/', { replace: true }) }}>◁
        </h1>
        <div className='container' ref={corpo}>
            <h2 style={{ marginTop: '1rem', textAlign: 'center' }}>PROFILO FOODTRUCK</h2>
            {msg.noProfilo && <h5 style={{ margin: '3em 0 14rem 0' }}>{msg.noProfilo}</h5>}
            {foodTrucks &&
                foodTrucks
                    .map((foodTruck) => {
                        let flag, write
                        if (foodTruck.accettazione === 'rejection') {
                            flag = '0.6'
                            write = '⛔ FoodTruck rifiutato, i contenuti non sono in linea con i nostri standard. ' +
                                "Modifica il contenuto usando un linguaggio più moderato"
                        }

                        if (foodTruck.accettazione === 'false') {
                            flag = '.7'
                            write = 'PROFILO FOODTRUCK IN FASE DI APPROVAZIONE'

                        }
                        return (
                            <div>
                                <div key={foodTruck.id} style={{ opacity: flag, marginTop: '2em' }} className='bodyPadding'>
                                    <h4 style={{ color: 'red', textAlign: 'center' }}><b>{write}</b></h4>
                                    {!foodTruck.img &&
                                        <img src={require('../userNotAuth//image/icons8-impostazioni-amministratore-maschio-32.png')} style={{ borderRadius: '50%', width: '30px', height: '30px', marginTop: '1rem' }} />
                                    }
                                    <span className='mt-1 float-end'>View: {foodTruck.view}</span>
                                    <hr />
                                    <h3 className='mt-2'><b>{foodTruck.nome}</b></h3>
                                    <p style={{ backgroundColor: 'maroon', color: 'white', width: 'fit-content', padding: '3px', marginTop: '1em' }}>{foodTruck.regione}</p>
                                    <p>CITTA': {foodTruck.città}</p>

                                    {tipoCucina.length !== 0 &&
                                        <div className='mt-5' style={{ border: '1px solid lightgrey', padding: '5px' }}>TIPO CUCINA:
                                            {tipoCucina.map((elem, index) => (
                                                <span key={index}> <i>{elem}{index < tipoCucina.length - 1 && <span>, </span>}</i>
                                                </span>
                                            ))}
                                            <div className='mt-4'>
                                                <img src={require('../userNotAuth/image/icons8-cucina-48.png')} width='25rem' />
                                                <span> {foodTruck.soggetto}</span>
                                            </div>
                                        </div>
                                    }

                                    <h5 className='mt-5 text-center'>⇩ DESCRIZIONE ⇩</h5>
                                    <textarea defaultValue={foodTruck.descrizione} style={{ fontStyle: 'italic', fontSize: 'medium' }} rows={6} className='form-control' />

                                    {img.length !== 0 &&
                                        <div className='mt-3'>
                                            <h4 className='text-center'>IMMAGINI DEL FOODTRUCK</h4>
                                            <div style={{ marginTop: '2em', display: 'flex', backgroundColor: 'whitesmoke' }} >
                                                {img.map((elem, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`} style={{ maxWidth: '110px', maxHeight: '100%', padding: '5px' }} />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    }
                                    {foodTruck.video &&
                                        <div className='mt-5' style={{ border: '1px solid lightgrey', borderRadius: '5px', padding: ' 15px' }}>
                                            <h5 className='text-center'>VIDEO DEL FOODTRUCK</h5>
                                            <div className='text-center mt-3'>
                                                <video src={`https://leuro-bucket.s3.amazonaws.com/video/${foodTruck.video}`} id={'videoPreview'}
                                                    style={{ width: '60%', maxHeight: '200px', borderRadius: '5px' }} controls />
                                            </div>
                                        </div>
                                    }

                                    {foodTruck.telefono &&
                                        <div className='mt-4'><img src={require('../userNotAuth/image/icons8-telefono-cellulare-48.png')} width='25rem' style={{ marginRight: '1rem' }} />
                                            {foodTruck.telefono}
                                        </div>
                                    }
                                    <div className='mt-1'><img src={require('../userNotAuth/image/icons8-nuovo-messaggio-48.png')} width="25rem" style={{ marginRight: '1rem' }} />
                                        {foodTruck.emailUser}
                                    </div>
                                    {foodTruck.url &&
                                        <div className='mt-3'>Sito web: <i style={{ fontWeight: '600' }}>
                                            <a href={foodTruck.url} target='_blank'>{foodTruck.url.substring(0, 28)}...</a>
                                        </i>
                                        </div>
                                    }
                                    {foodTruck.fb &&
                                        <div className='mt-2'>F Book: <i style={{ fontWeight: '600' }}>
                                            <a href={foodTruck.fb} target='_blank'>{foodTruck.fb.substring(0, 28)}...</a>
                                        </i>
                                        </div>
                                    }
                                    {foodTruck.youtube &&
                                        <div className='mt-2'>Y Tube: <i style={{ fontWeight: '600' }}>
                                            <a href={foodTruck.youtube} target='_blank'>{foodTruck.youtube.substring(0, 28)}...</a>
                                        </i>
                                        </div>
                                    }
                                    <hr />
                                    <div className='mt-4' style={{ marginBottom: '6rem' }}>
                                        <button className='btn btn-primary float-start' onClick={() => { modifica(foodTruck) }}
                                            style={{ fontSize: 'medium' }}>
                                            Modifica
                                        </button>
                                        <button className='btn btn-danger float-end' style={{ fontSize: 'medium' }}
                                            onClick={() => {
                                                setDati(foodTruck)
                                                document.body.style.overflow = "hidden"
                                                corpo.current.style.opacity = ".4"
                                                confirmElimina.current.style.top = '30%'
                                            }}>
                                            Elimina
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
            <p style={{ cursor: 'pointer', margin: '2em 0 0 .5em' }} onClick={() => { navigate('/', { replace: true }) }}>◁ <i>indietro</i>
            </p>
            {foodTrucks.length === 0 && <h4 className='text-center mt-5'>Non hai nessun profilo FoodTruck</h4>}
        </div>
        <DivBottom />
    </>)
}
export default ProfiloFoodTruck